import React from 'react';
import './Step1Infos.css';

const Step1Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-1">
            Richiedi subito il tuo preventivo online con la detrazione fiscale
            fino al 50%.
        </div>
    );
};

export default Step1Infos;
